import cfg from '../services/configuration/PropertiesConfiguration'

export class ForgotCredentialsService {

  constructor (axios) {
    this.axios = axios
  }

  getSecurityQuestions (memberInfo) {
    return this.axios.post(cfg.securityQuestionsEndpoint, memberInfo)
  }

  submitForgotUsername (memberInfo) {
    return this.axios.post(cfg.forgotUsernameEndpoint, memberInfo)
  }

  submitForgotPassword (memberInfo) {
    return this.axios.post(cfg.forgotPasswordEndpoint, memberInfo)
  }
}



// WEBPACK FOOTER //
// ./src/services/ForgotCredentialsService.js